module.exports = function() {
  return new Worker("/" + "pug-transpiler.72b53cba.worker.js");
};